"use client";

import type { Message } from "@/lib/core/crm/types";
import { MODAL_IDS, ResponsiveModal } from "@west-tennessee-consulting/ui";
import { SaveAttachmentsModalActions } from "./SaveAttachmentsModalActions";
import { SaveAttachmentsModalBody } from "./SaveAttachmentsModalBody";
import { useSaveAttachmentsToGoogleDriveState } from "./useSaveAttachmentsToGoogleDriveState";

interface SaveAttachmentsToGoogleDriveModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message: Message;
  globalModalId?: string;
}

export function SaveAttachmentsToGoogleDriveModal({
  open,
  onOpenChange,
  message,
  globalModalId = MODAL_IDS.messages.saveAttachmentsToGoogleDrive,
}: SaveAttachmentsToGoogleDriveModalProps) {
  if (!message) {
    return null;
  }

  return (
    <SaveAttachmentsToGoogleDriveModalContent
      globalModalId={globalModalId}
      message={message}
      onOpenChange={onOpenChange}
      open={open}
    />
  );
}

function SaveAttachmentsToGoogleDriveModalContent({
  open,
  onOpenChange,
  message,
  globalModalId,
}: Required<SaveAttachmentsToGoogleDriveModalProps>) {
  const state = useSaveAttachmentsToGoogleDriveState({
    message,
    onOpenChange,
    open,
  });

  return (
    <ResponsiveModal
      open={open}
      onOpenChange={onOpenChange}
      title="Save Attachments to Google Drive"
      description={`Select a client folder for: ${message.subject}`}
      globalModalId={globalModalId}
    >
      <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-2">
        <SaveAttachmentsModalBody state={state} />

        <SaveAttachmentsModalActions
          attachments={state.attachments}
          hasDestination={state.hasDestination}
          isLoading={state.isLoading}
          isUploading={state.isUploading}
          onClose={state.handleClose}
          onUpload={state.handleUpload}
          selectedAttachmentCount={state.selectedAttachmentIds.size}
          uploadResults={state.uploadResults}
        />
      </div>
    </ResponsiveModal>
  );
}
